import { Box, Container, Table, TableCell, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react';


class Template1 extends Component {
    state = {  }
    render() {
        return (
            <Container maxWidth="md" style={{border: "1px solid", height: "900px"}}>
                <Box style={{height:"300px", background: "cornsilk"}}>
                    
                </Box>
                <hr />
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>PU</TableCell>
                            <TableCell>Prix Total</TableCell>
                        </TableRow>
                    </TableHead>
                </Table>
            </Container>
        );
    }
}

export default Template1;